export default function Go_Error_Handling () {
  return (
    <div>
      <h1>Go_Error_Handling </h1>
      <p>Go Error Handling</p>
    </div>
  );
}